import { appBoxIcon } from './box';
import { appClipboardIcon } from './clipboard';
import { appFile05Icon } from './file-05';
import { appFileSearch02Icon } from './file-search-02';
import { appFolderIcon } from './folder';
export const filesIcons = [appBoxIcon, appClipboardIcon, appFile05Icon, appFileSearch02Icon, appFolderIcon];
